import React, { useState } from 'react';

import SummaryAccordionBlock from 'components/molecules/summary_accordion_block';
import { mapStringsToBulletLi } from 'components/molecules/bidding_summary_bullet_list';
import { getExigenciasEspecificasEntries } from 'components/molecules/bidding_summary_utils';

import type { ExigenciasEspecificas } from 'store/modules/bidding_summary_store/types';

import iconSummarySegments from 'assets/images/icon_summary_segments.svg';

interface BiddingSummaryExigenciasEspecificasProps {
  exigencias?: ExigenciasEspecificas;
}

const BiddingSummaryExigenciasEspecificas: React.FC<BiddingSummaryExigenciasEspecificasProps> = ({
  exigencias,
}) => {
  const entries = getExigenciasEspecificasEntries(exigencias);
  const [openState, setOpenState] = useState<Record<string, boolean>>(() =>
    Object.fromEntries(entries.map((entry) => [entry.key, true])),
  );

  if (!entries.length) return null;

  return (
    <>
      {entries.map(({ key, items }) => (
        <SummaryAccordionBlock
          key={key}
          open={openState[key] ?? true}
          onToggle={() =>
            setOpenState((prev) => ({
              ...prev,
              [key]: !prev[key],
            }))
          }
          accordionPanelId={`bidding-summary-panel-exigencias-${key}`}
          title="Exigência Específicas"
          iconSrc={iconSummarySegments}
          badge={key.trim()}
          cardClassName="summary-accordion-card--exigencias-border"
          headerClassName="accordion-section-toggle--exigencias-soft"
        >
          <ul className="pl-4 mb-0 bidding-summary-exigencias-list">
            {mapStringsToBulletLi(`exigencia-${key}`, items)}
          </ul>
        </SummaryAccordionBlock>
      ))}
    </>
  );
};

export default BiddingSummaryExigenciasEspecificas;
